import * as Sentry from "@sentry/vue";

Sentry.init({
  release: window.dealerkit.ui_version,
  environment: window.dealerkit.environment,
  dsn: window.dealerkit.sentry_dsn,
  tracesSampleRate: window.dealerkit.sentry_trace_sample_rate,
  ignoreErrors: [
      "AxiosError: Request failed with status code 403",
      "Non-Error promise rejection captured with value: undefined",
      "Request failed with status code 401",
      "Avoided redundant navigation to current location",
      "timeout of 0ms exceeded",
      "Network Error",
      "undefined is not an object (evaluating 'c.matched')",
      "The index is not in the allowed range",
      "AxiosError: Request aborted",
      'Could not load "util".'
  ],
  denyUrls: [
      // Benign errors thrown by a third-party analytics SDK (frame-modern.*.js)
      // when its iframe is detached and an async flush reads parent.document.cookie.
      /frame-modern.*\.js/
  ],
  integrations: [Sentry.browserTracingIntegration()],
})

Sentry.setUser({
    'id': window.marque.ui.user.id,
    'name':  window.marque.ui.user.name,
    'email':  window.marque.ui.user.email
});

Sentry.setTag('account_id', window.marque.ui.account.id);
Sentry.setTag('account_name', window.marque.ui.account.name);


window.Sentry = Sentry;